import { Form, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import './secciones.scss';
import { MONITOREOS_VISITAS_VERIFICACION } from 'constants/tipoMonitoreos';

const SeccionDatosHallazgos = ({ form, tipoMon }) => {
  return (
    <div>
      <Form form={form} layout="horizontal">
        <div className="container-datos">
          <Form.Item name="tipoHallazgo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ tipoHallazgo: target.checked });
              }}>
              Tipo de hallazgo
            </Checkbox>
          </Form.Item>
          <Form.Item name="cantidad">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ cantidad: target.checked });
              }}>
              Cantidad
            </Checkbox>
          </Form.Item>
          <Form.Item name="tipoMedida">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ tipoMedida: target.checked });
              }}>
              Tipo de medida
            </Checkbox>
          </Form.Item>
          <Form.Item name="medida">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ medida: target.checked });
              }}>
              Medida
            </Checkbox>
          </Form.Item>
          <Form.Item name="color">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ color: target.checked });
              }}>
              Color
            </Checkbox>
          </Form.Item>
          <Form.Item name="placas">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ placas: target.checked });
              }}>
              Placas
            </Checkbox>
          </Form.Item>
          <Form.Item name="idINE">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ idINE: target.checked });
              }}>
              ID INE
            </Checkbox>
          </Form.Item>
          <Form.Item name="lemaHallazgo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ lemaHallazgo: target.checked });
              }}>
              Lema
            </Checkbox>
          </Form.Item>
          <Form.Item name="duracionHallazgo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ duracionHallazgo: target.checked });
              }}>
              Duración
            </Checkbox>
          </Form.Item>
          <Form.Item name="propagandaAnterior">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ propagandaAnterior: target.checked });
              }}>
              ¿Es propaganda de campaña anterior?
            </Checkbox>
          </Form.Item>
          <Form.Item name="infoAdicionalHallazgo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ infoAdicionalHallazgo: target.checked });
              }}>
              Información adicional (modo, tiempo, lugar)
            </Checkbox>
          </Form.Item>
          {tipoMon === MONITOREOS_VISITAS_VERIFICACION && (
            <>
              <Form.Item name="muestra1">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ muestra1: target.checked });
                  }}>
                  Muestra 1
                </Checkbox>
              </Form.Item>
              <Form.Item name="muestra2">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ muestra2: target.checked });
                  }}>
                  Muestra 2
                </Checkbox>
              </Form.Item>
              <Form.Item name="muestra3">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ muestra3: target.checked });
                  }}>
                  Muestra 3
                </Checkbox>
              </Form.Item>
              <Form.Item name="muestra4">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ muestra4: target.checked });
                  }}>
                  Muestra 4
                </Checkbox>
              </Form.Item>
              <Form.Item name="muestra5">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ muestra5: target.checked });
                  }}>
                  Muestra 5
                </Checkbox>
              </Form.Item>
            </>
          )}
        </div>
      </Form>
    </div>
  );
};

export default SeccionDatosHallazgos;

SeccionDatosHallazgos.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired,
  tipoMon: PropTypes.number.isRequired
};
